var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldExclamationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V7.33333M8 10H8.00667M13.7453 3.98933C11.6374 4.10128 9.57116 3.37241 8 1.96267C6.42885 3.37241 4.3626 4.10128 2.25467 3.98933C2.08502 4.64608 1.99945 5.3217 2 6C2 9.72733 4.54934 12.86 8 13.748C11.4507 12.86 14 9.728 14 6C14 5.30533 13.9113 4.632 13.7453 3.98933Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldExclamationOutline);
export default __webpack_public_path__ + "static/media/ShieldExclamationOutline.aede4e6b020c76dc849aa6b0282ea195.svg";
export { ForwardRef as ReactComponent };